export { default } from './StepsSection';
